import { ThemeType } from "@itwin/itwinui-react";
import { editor } from "monaco-editor/esm/vs/editor/editor.api";

export const setTheme = (theme?: ThemeType) => {
  editor.defineTheme("sandbox-dark", {
    base: "vs-dark",
    inherit: true,
    //rules: [],
    rules: [{ token: "minimap", background: "#242b2e" }], // This is needed for minimap background
    colors: {
      "editor.background": "#242b2e",
    }
  });

  editor.setTheme((theme === "dark" && "sandbox-dark") || (theme === "light" && "vs") || "vs");
}
